import React from 'react';
import ListBots from '../components/ListBots/ListBots';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

export default function CaseListBots() {
    return (
        <AuthenticatedLayout title="Lista de Bots">
            <ListBots />
        </AuthenticatedLayout>
    );
}
